module.exports = __webpack_public_path__ + "static/media/  (108).de2d55f4.jpg";